"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.titleCase = exports.default = void 0;
const isWhitespaces = str => str.match(/^\s+$/);
const titleCase = str => str.split(' ').map(word => {
  if (word !== word.toUpperCase()) {
    const lowerCaseWord = word.toLowerCase();
    return lowerCaseWord.replace(lowerCaseWord.charAt(0), lowerCaseWord.charAt(0).toUpperCase());
  } else {
    return word;
  }
}).join(' ');
exports.titleCase = titleCase;
var _default = exports.default = isWhitespaces;